import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchSwimmingPoolCompanies, deleteSwimmingPoolCompany } from "../Reducers/actions";

const SwimmingPoolsPage = () => {
  const dispatch = useDispatch();
  const { swimmingPoolCompanies, loading } = useSelector(state => state.zwembadinspecties);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(fetchSwimmingPoolCompanies());
  }, [dispatch]);

  const handleDelete = (id) => {
    if (window.confirm("Weet je zeker dat je dit zwembad wilt verwijderen?")) {
      dispatch(deleteSwimmingPoolCompany(id));
    }
  };

  const filteredCompanies = swimmingPoolCompanies.filter(company =>
    company.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company.city?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3>Zwembaden Beheer</h3>
              <Link to="/zwembadinspecties/zwembaden/nieuw" className="btn btn-primary">
                <i className="fas fa-plus"></i> Nieuw Zwembad
              </Link>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Zoek op naam of plaats..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>

              {loading ? (
                <div className="text-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Laden...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Naam</th>
                        <th>Type</th>
                        <th>Plaats</th>
                        <th>Contactpersoon</th>
                        <th>Telefoon</th>
                        <th>Status</th>
                        <th>Acties</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredCompanies.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Geen zwembaden gevonden
                          </td>
                        </tr>
                      ) : (
                        filteredCompanies.map((company) => (
                          <tr key={company._id}>
                            <td>{company.name}</td>
                            <td>{company.pool_type}</td>
                            <td>{company.city}</td>
                            <td>{company.contact_name}</td>
                            <td>{company.contact_phone}</td>
                            <td>
                              <span className={`badge ${company.is_active ? 'badge-success' : 'badge-secondary'}`}>
                                {company.is_active ? 'Actief' : 'Inactief'}
                              </span>
                            </td>
                            <td>
                              <Link
                                to={`/zwembadinspecties/inspecties?company_id=${company._id}`}
                                className="btn btn-sm btn-primary me-2"
                                title="Inspecties bekijken"
                              >
                                <i className="fas fa-clipboard-list"></i>
                              </Link>
                              <Link
                                to={`/zwembadinspecties/zwembaden/${company._id}`}
                                className="btn btn-sm btn-info me-2"
                                title="Bewerken"
                              >
                                <i className="fas fa-edit"></i>
                              </Link>
                              <button
                                onClick={() => handleDelete(company._id)}
                                className="btn btn-sm btn-danger"
                                title="Verwijderen"
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwimmingPoolsPage;
